import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const transcriptContents: CaseReducer<NinchatState> = (state) => state
